/*
 * dns-external-links.js
 * Open every external link (a different hostname) in a new tab, sitewide.
 * Internal links (relative, or the store's own domain) are left untouched.
 * Runs once on load and watches for late-injected content (menus, apps).
 */
(function () {
  var host = window.location.hostname;

  function markExternal(a) {
    if (!a || a.dataset.dnsExt === '1') return;
    // Only real web links — skip mailto:, tel:, #anchors, javascript:, etc.
    if (a.protocol !== 'http:' && a.protocol !== 'https:') return;
    // Same host = internal (relative hrefs resolve to the current host).
    if (!a.hostname || a.hostname === host) return;

    a.dataset.dnsExt = '1';
    a.setAttribute('target', '_blank');

    // Preserve any existing rel tokens, guarantee noopener + noreferrer.
    var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    ['noopener', 'noreferrer'].forEach(function (t) {
      if (rel.indexOf(t) === -1) rel.push(t);
    });
    a.setAttribute('rel', rel.join(' '));
  }

  function scan(root) {
    (root || document).querySelectorAll('a[href]').forEach(markExternal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Catch links added after load (cart drawer, predictive search, app widgets).
  if ('MutationObserver' in window) {
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'A') markExternal(n);
          if (n.querySelectorAll) scan(n);
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
